import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['merchType', 'hat', 'fieldSign']

  handleMerchTypeChange(event) {
    const selectedType = event.target.value;
    this.hatTarget.style.display = selectedType === 'hat' ? 'block' : 'none';
    this.fieldSignTarget.style.display = selectedType === 'field_sign' ? 'block' : 'none';
  }
}
